/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description Affichage des portails de connexions vers la DAO.

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React from 'react';
import PortalsButton from './portalsButton';
import { faIdCard, faVoteYea} from '@fortawesome/free-solid-svg-icons';

const Portals = (props) => {

	return (
		<div className={`portals ${props.className}`}>
			<PortalsButton 
				icon={faIdCard}
				translateOnHover={props.translateOnHover}
				text="NEDID"
				tooltip="Le portail d'identité décentralisée de NEDAO."
				className="dao"
				url="https://did.nedao.ch/" />
			<PortalsButton 
				icon={faVoteYea}
				translateOnHover={props.translateOnHover}
				text="NEDAO"
				tooltip="La plateforme de propositions et de votes de NEDAO."
				className="dao2"
				url="https://vote.nedao.ch" />
		</div>
	);
};

export default Portals;
